export var compMathMethodExperimentalDesign = {
    name: 'Experimental design',
    id: 'compMathMethodExperimentalDesign',
    depth: 2,
    enableToInclueOtherTagToTopLevel: true,
    tags: [
        {
            name: 'Modeling computational processes of the brain',
            id: 'yK7ftp'
        },
        {
            name: 'Model-fitting',
            id: 'qB6LYD'
        },
        {
            name: 'Simulated lesion',
            id: 'Ua7X4c'
        },
        {
            name: 'Classification/Discrimination',
            id: 'z6S53x'
        },
        {
            name: 'Clustering',
            id: 'v9N6cq'
        },
        {
            name: 'Prediction of disease states',
            id: 'iW7eyF'
        },
        {
            name: 'Others',
            id: 'e8KALN',
            children: [
                {
                    name: 'Unspecified',
                    id: 'bH4tJq'
                }
            ]
        }
    ]
};
export var compMathMethodDataType = {
    name: 'Data type',
    id: 'compMathMethodDataType',
    depth: 2,
    enableToInclueOtherTagToTopLevel: true,
    tags: [
        {
            name: 'Simulation',
            id: 'Xr9Aak'
        },
        {
            name: 'Human experiment',
            id: 'As3Dzj'
        },
        {
            name: 'Animal experiment',
            id: 'u9L3GW'
        },
        {
            name: 'Literature review',
            id: 'Sv5DnP'
        },
        {
            name: 'Others',
            id: 'Q3pLUg',
            children: [
                {
                    name: 'Unspecified',
                    id: 'y6GSdA'
                }
            ]
        }
    ]
};
export var compMathMethodModels = {
    name: 'Models',
    id: 'compMathMethodModels',
    depth: 2,
    enableToInclueOtherTagToTopLevel: true,
    tags: [
        {
            name: 'Reinforcement learning',
            id: 'z6KWmx'
        },
        {
            name: 'Biophysical model',
            id: 'uS3gqz'
        },
        {
            name: 'Neural network model',
            id: 'X7gWvC'
        },
        {
            name: 'Bayes',
            id: 'pG6u5r'
        },
        {
            name: 'Regression model',
            id: 'F4cZbp'
        },
        {
            name: 'Others',
            id: 'rK7EQV',
            children: [
                {
                    name: 'Active inference',
                    id: 'kB6cAz'
                },
                {
                    name: 'Drift diffusion model',
                    id: 'D2b98G'
                },
                {
                    name: 'Hidden Markov model (HMM)',
                    id: 'jC4ueX'
                },
                {
                    name: 'Support vector machine (SVM)',
                    id: 'Nn6P4f'
                },
                {
                    name: 'k-means',
                    id: 'Nf7xPs'
                },
                {
                    name: 'Factor analysis',
                    id: 'i4MnRs'
                },
                {
                    name: 'Independent component analysis (ICA)',
                    id: 'Dy9w43'
                },
                {
                    name: 'Gaussian mixture model (GMM)',
                    id: 'H4uYc5'
                },
                {
                    name: 'Other models',
                    id: 'b6BCk9'
                },
                {
                    name: 'Unspecified',
                    id: 'Lj6Ae8'
                }
            ]
        }
    ]
};
